import clsx from 'clsx';
import React__default from 'react';

const Label = ({ children, className, required, htmlFor, ...labelProps }) => {
    const props = {
        className: clsx('c-input-label', className),
        required,
        htmlFor,
        ...labelProps
    };
    return React__default.createElement("label", { ...props }, children);
};

export { Label };
//# sourceMappingURL=Label.js.map
